import { render, staticRenderFns } from "./FGCollapsiblePanel.vue?vue&type=template&id=2e04a816&scoped=true"
import script from "./FGCollapsiblePanel.vue?vue&type=script&lang=js"
export * from "./FGCollapsiblePanel.vue?vue&type=script&lang=js"
import style0 from "./FGCollapsiblePanel.vue?vue&type=style&index=0&id=2e04a816&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e04a816",
  null
  
)

export default component.exports